export function bookingLocationLabel(booking = {}, {showMeetingLink = true} = {}) {
  booking = booking || {};
  const location = booking.savedLocation;
  if (!location) {
    return (
      (showMeetingLink && booking.zoomLink) ||
      booking.branchName ||
      (booking.zoomLink ? 'Online session' : '')
    );
  }
  if (location.type === 'virtual' && !showMeetingLink) return location.name || 'Online session';
  const details = location.type === 'address' ? location.address
    : location.type === 'virtual' ? location.url : (location.notes || '').replace(/<[^>]*>/g, '');
  return [location.name, details].filter(Boolean).join(' — ');
}

export function branchLocationLabel(branch) {
  if (!branch) return '';
  const address = branch.isVirtual ? '' : ['street', 'city', 'state', 'zip', 'country']
    .map(key => String(branch[key] || '').trim()).filter(Boolean).join(', ');
  return bookingLocationLabel({savedLocation: {name: branch.name, type: 'address', address}});
}
